module.exports = __webpack_public_path__ + "img/full7-min.51841b3c.png";